import React from 'react'
import classNames from 'classnames'
import {
  Field,
  Select,
} from '@lightspeed/unified-components-helios-theme/react'
import { FulfillmentOutlet } from '../../types'
import { useOutletToFulfilFromModel } from './useOutletToFulfilFromModel'

export interface OutletToFulfilFromProps {
  outlets: FulfillmentOutlet[]
  className?: string
  onOutletChange: (outlet: string) => void
  currentOutlet: string
}

export const OutletToFulfilFrom: React.FC<OutletToFulfilFromProps> = props => {
  const models = useOutletToFulfilFromModel(props)

  return (
    <div className={classNames('uc-base', props.className)}>
      <Field labelSlot={models.label}>
        <Select
          value={props.currentOutlet}
          options={models.outlets}
          onChange={models.onOutletChange}
          size="medium"
        />
      </Field>
    </div>
  )
}

OutletToFulfilFrom.displayName = 'OutletToFulfilFrom'
